var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.58 17.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,2.48A8.43,8.43,0,0,0,8.78,0,8.88,8.88,0,0,0,0,8.94a8.63,8.63,0,0,0,8.65,8.64H8.8A8.83,8.83,0,0,0,15,2.48ZM1.58,8.92A7.29,7.29,0,0,1,8.8,1.58h.13a7,7,0,0,1,4.34,1.5.83.83,0,0,0-.12.08L3.06,13.25A7.36,7.36,0,0,1,1.58,8.92ZM8.78,16H8.65a7,7,0,0,1-4.32-1.47l10.1-10.1a.53.53,0,0,0,.06-.1A7.24,7.24,0,0,1,8.78,16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/not-allowed.f26c26858fdb3d76fe0469af712f1abd.svg";
export { ForwardRef as ReactComponent };